import { connect } from "react-redux";
import RequiredDocuments from "./RequiredDocuments";
import { bindActionCreators } from "redux";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";
import { getSiteStage, saveStagesDocuments } from "services/redux/installation/siteStages/action";
const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  siteStageData: state.siteStageReducer.siteStageData,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getSiteStage,
      saveStagesDocuments
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(RequiredDocuments);